import { Fragment } from 'react';
import PropTypes from 'prop-types'
import WorkflowSection from '../Section/WorkflowSection'
import '../Section/section.css'
import T from 'i18n-react';
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import LayoutActions from '../../../reducers/layoutRedux';
import { getIcon } from '../../../utils/IconUtil';
import classnames from 'classnames';

const InProgressBlankStateReturnSection = ({ taxState, isWaitingToFile, section }) => {
    const dispatch = useDispatch();

    return (
        <WorkflowSection
            titleKey=''
            titleKeyProps={{ TaxYear: taxState.taxYear }}
            isVIR={taxState.is_vir}
            isAlternate={false} 
            canClose={false}
            ticketType={taxState.ticket_type}>
            <div className='wf-upload-docs-complete-container-WF'>
                <div className='wf-documents-complete-icon'>
                    <img src={section === 'manual_payment' ? getIcon('manual-prepare-payment-complete') : getIcon('documents-step-complete')} />
                </div>
                <div className={classnames("wf-section-label-container wf-section-label-extra-spacing wf-section-label-container-remove-spacing", 'wf-section-label-extra-spacingWF')}>
                    {isWaitingToFile ?
                        T.translate(`WorkflowPanel.upload-docs.subtext.completed_vir`) :
                        <Fragment>
                            <div className='wf-complete-title'>{T.translate(`WorkflowPanel.upload-docs.subtext.completedTitleWF`+`_`+section)}</div>
                            <div className='wf-complete-body'>{T.translate(`WorkflowPanel.upload-docs.subtext.completedBodyWF`+`_`+section, { documents: <Link to='' onClick={() => dispatch(LayoutActions.setDashboardTab('documents'))}><b>documents</b></Link> })}</div>
                        </Fragment>
                    }
                </div>
            </div>
        </WorkflowSection>
    )
}

InProgressBlankStateReturnSection.propTypes = {
    taxState: PropTypes.shape({
        taxYear: PropTypes.number.isRequired
    }),
    isWaitingToFile: PropTypes.bool
}

export default InProgressBlankStateReturnSection;

